import { getBoggleChallengeGridSizeInfo } from '~/boggle/gameModes/gridSizeVariants'
import type { BoggleChallengeCoreDefinition } from '~/boggle/gameModes/types'
import type { BoggleGridSize, BogglePlaygroundSettings } from '~/boggle/config/playground'

export const BOGGLE_CHALLENGE_GRID_SIZE_CORE_DEFINITION = {
  createPatch: (value: BoggleGridSize) => ({
    gridSize: value,
  }),
  getInfo: getBoggleChallengeGridSizeInfo,
  id: 'grid-size',
  label: 'Grid',
  readValue: (settings: BogglePlaygroundSettings) => settings.gridSize,
  renderValue: (value: BoggleGridSize) => value,
} satisfies BoggleChallengeCoreDefinition<BoggleGridSize>
